import React from 'react'
import classnames from 'classnames'

const StageStepper = ({ stages, current }) => {
  const currentIndex = stages.findIndex(({ id }) => id === current)

  return (
    <ol className="bulk-edit-stepper">
      <For each="stage" index="index" of={stages}>
        <li
          key={stage.id}
          className={classnames('bulk-edit-stepper__step', {
            'bulk-edit-stepper__step--active': index === currentIndex,
            'bulk-edit-stepper__step--done': index < currentIndex,
          })}
        >
          <span className="bulk-edit-stepper__number">{index + 1}</span>
          <span className="bulk-edit-stepper__label">{stage.label}</span>
        </li>
      </For>
    </ol>
  )
}

export default StageStepper
